import { render, staticRenderFns } from "./ed-section-tree.vue?vue&type=template&id=18c1c0a0&scoped=true&"
import script from "./ed-section-tree.ts?vue&type=script&lang=js&"
export * from "./ed-section-tree.ts?vue&type=script&lang=js&"
import style0 from "./ed-section-tree.scss?vue&type=style&index=0&id=18c1c0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1c0a0",
  null
  
)

export default component.exports